import routes from '../routes';
import { UserTypes } from 'src/modules/Auth/store/types';
import { RoutePathsFn, IRouteModule, RoutesModules } from '../types';
import Agency from '../../Agencies/Agency/Add/Agency';
import AgencyInfo from '../../Agencies/Agency/View/components/AgencyInfo';
import AgenciesView from '../../Agencies/Agency/View/AgenciesView';
import ManagersView from '../../Agencies/Manager/View/ManagersView';
import { AgenciesManagers } from '../../Agencies/Manager/Add/Manager';
import { AgenciesManagerInfo } from '../../Agencies/Manager/View/components/ManagerInfo';

const moduleRoutes: RoutePathsFn = () => ([
  {
    paths: [routes.ADDAGENCY, routes.EDITAGENCY],
    component: Agency,
    policies: [UserTypes.ADMIN]
  },
  {
    paths: [routes.AGENCYINFO],
    component: AgencyInfo,
    policies: [UserTypes.CASEMANAGER, UserTypes.ADMIN]
  },
  {
    paths: [routes.AGENCIES, routes.AGENCIESVIEW],
    component: AgenciesView,
    policies: [UserTypes.CASEMANAGER, UserTypes.ADMIN]
  },
  {
    paths: [routes.MANAGERSVIEW],
    component: ManagersView,
    policies: [UserTypes.CASEMANAGER, UserTypes.ADMIN]
  },
  {
    paths: [routes.ADDMANAGER, routes.EDITMANAGER],
    component: AgenciesManagers,
    policies: [UserTypes.ADMIN]
  },
  {
    paths: [routes.MANAGERINFO],
    component: AgenciesManagerInfo,
    policies: [UserTypes.CASEMANAGER, UserTypes.ADMIN]
  },

]);

export const agenciesModule = (): IRouteModule => ({
  name: RoutesModules.AGENCIES,
  routes: moduleRoutes(),
  navbar: routes.AGENCIESVIEW,
  sidebar: [
    {
      navTitle: 'Add new agency',
      route: routes.ADDAGENCY,
    },
    {
      navTitle: 'Agencies',
      route: routes.AGENCIESVIEW
    },
    {
      navTitle: 'Add new manager',
      route: routes.ADDMANAGER,
    },
    {
      navTitle: 'Managers',
      route: routes.MANAGERSVIEW,
    }
  ]
})



// WEBPACK FOOTER //
// ./src/modules/Routing/modules/agencies.ts